/** Summarize conversation when history exceeds this many messages. */
export const SUMMARY_THRESHOLD  = 40;

/** Keep this many recent messages verbatim after summarizing. */
export const SUMMARY_KEEP_RECENT = 12;

/** Generate/refine chat title at these user-message-count milestones. */
export const TITLE_MILESTONES = [2, 5, 10];

/** Refine title every N cumulative user messages after the milestones. */
export const TITLE_INTERVAL = 25;
